import { useState } from "react";
import { Button } from "@/components/ui/button";
import { MessageSquarePlus } from "lucide-react";
import { BulkSMSModal } from "./BulkSMSModal";

interface BulkSMSButtonProps {
    selectedIds: number[];
}

export const BulkSMSButton = ({ selectedIds }: BulkSMSButtonProps) => {
    const [open, setOpen] = useState(false);

    if (selectedIds.length === 0) {
        return null;
    }

    return (
        <>
            <Button
                variant="outline"
                size="sm"
                onClick={() => setOpen(true)}
            >
                <MessageSquarePlus className="h-4 w-4 mr-2" />
                Send Bulk SMS ({selectedIds.length})
            </Button>
            <BulkSMSModal
                open={open}
                onOpenChange={setOpen}
                contactIds={selectedIds}
            />
        </>
    );
};
